import { Entity } from '../../../data/dto/entity';
import { Dto } from '../../../data/dto/dto';
import { DTO_DEFAULT, DtoType } from '../../../data/dto/dto-types';
import { DtoExport, DtoImport } from '@core/utils/dto';
import { VerificationPicture } from './verification-picture';
import { DeliveryOrderDropoffVerificationSchema } from './delivery-order-dropoff-verification.schema';

export class DeliveryOrderDropoffVerification implements Entity {
    public signature: string;
    public pinCode: number;
    public identification: string;
    public picture: VerificationPicture;
    public barcodes: string[];

    @DtoImport(DeliveryOrderDropoffVerificationSchema)
    static import(dto: Dto): any {}

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderDropoffVerificationSchema,
        },
    ])
    export(type?: DtoType): any {}
}
